<template>
    <div class="invoice-success">
        <el-button class="handleRedflushSubmit" @click="handleRedflushSubmit">确定</el-button>
    </div>
</template>

<script>

export default {
    name: "invoiceSuccess",
    components: {
    },

    data() {
        return {
            value: 1,
        };
    },

    computed: {
    },

    methods: {
        handleRedflushSubmit() {
            this.$emit('handleClickSure', '')
        }
    },
};
</script>

<style lang="scss" scoped>
.invoice-success {
    text-align: center;

    .tips {
        font-size: 14px;
        color: #fff;
    }

    .object-wrap {
        .object {
            margin-top: 15px;
            width: 100%;
            text-align: left;
            padding: 15px;
            box-sizing: border-box;
            background: #fff;
            border-radius: 5px;

            .tit {
                font-weight: bold;
                color: var(--main-color);
                margin-bottom: 5px;
            }

            .info {
                color: #999;
                line-height: 24px;
            }
        }
    }
    .el-select {
        width: 100%;
        margin-top: 15px;
    }

    .handleRedflushSubmit {
        width: 100%;
        margin-top: 15px;
        color: var(--main-color);
    }
}
</style>